<template>
  <div>
    <v-autocomplete
      v-model="form.value"
      :items="fieldTypes"
      :value-comparator="selectComparator"
      :disabled="shouldDisableUpdate"
      :validator="vs.form.value.component"
      label="Type"
      box
      item-text="display"
    />
    <text-field
      v-model.trim="form.name"
      :validator="vs.form.name"
      :disabled="shouldDisableUpdate"
      label="Label"
      type="text"
    />
    <div v-if="['dropdown', 'checkbox', 'radio-button'].includes(form.value.type)">
      <div
        v-for="(item, index) in form.value.items.length"
        :key="index"
        style="display: flex; gap: 1rem; align-items: flex-start"
      >
        <text-field
          v-model.trim="form.value.items[index]"
          :disabled="shouldDisableUpdate"
          label="Option"
          type="text"
        />
        <v-icon style="margin-top: 1rem" @click="deleteOption(index)"> delete</v-icon>
      </div>
      <div
        class="add-another-container"
        :class="form.value.items[form.value.items.length - 1] === '' ? 'disabled-button' : ''"
        @click="addAnotherOption()"
      >
        <v-icon class="size-32" icon color="primary">add</v-icon>
        <div class="promo-text">Add another option</div>
      </div>
    </div>
    <div v-if="form.value.type === 'consent'">
      <textarea-field v-model="form.value.item" label="Text fields" type="text" />
    </div>
    <div v-if="form.value.type === 'rich-text-editor'">
      <text-editor-field v-model="form.item" placeholder="Description" />
    </div>
    <div class="switch-container">
      <div v-if="action === 'add' && attendeesExist && form.value.validations.hasOwnProperty('required')">
        <p class="button-label">Required</p>
        <v-tooltip top color="#979797">
          <v-switch
            slot="activator"
            v-model="form.value.validations.required"
            color="#ff4c00"
            :disabled="true"
          />
          <span>Cannot set field as required if attendees exist.</span>
        </v-tooltip>
      </div>
      <div v-else class="switch-container">
        <div v-if="form.value.validations.hasOwnProperty('required')">
          <p class="button-label">Required</p>
          <v-switch
            v-model="form.value.validations.required"
            color="#ff4c00"
            :disabled="attendeesExist"
          />
        </div>
        <div>
          <p class="button-label">Hidden from attendees</p>
          <v-switch
            v-model="form.isPrivate"
            color="#ff4c00"
            :disabled="form.value.validations.required"
          />
        </div>
      </div>
      <div v-if="form.value.type === 'dropdown'">
        <p class="button-label">Multiselect</p>
        <v-switch slot="activator" v-model="multiselect" color="#ff4c00" class="mt-0" />
      </div>
    </div>
  </div>
</template>

<script>
import { ATTENDEE_FIELDS_OPTIONS } from '../accreditations/attendee-fields'

export default {
  name: 'attendee-field-form',
  props: {
    vs: {
      type: Object,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    fields: {
      type: Array,
      default: () => [],
    },
    attendeesExist: {
      type: Boolean,
      default: false,
    },
    action: String,
  },
  data() {
    return {
      form: {
        value: { validations: { required: false } },
        isPrivate: false,
        ...this.initialValues,
      },
      newSelectField: '',
      fieldTypes: ATTENDEE_FIELDS_OPTIONS,
      multiselect: false,
    }
  },

  computed: {
    shouldDisableUpdate() {
      return this.action === 'update' ? this.attendeesExist : false
    },
  },
  watch: {
    form: {
      handler(value) {
        if(value.value.fieldID === 'section-label') {
          delete this.form.value.validations.required
        }

        if (this.form.value.validations.required) {
          this.form.isPrivate = false
        }
        this.$emit('values', value)
      },
      deep: true,
    },
    multiselect: {
      handler(value) {
        if (value) {
          this.form.value.component = 'select-field-multiple'
        } else {
          this.form.value.component = 'select-field'
        }
      },
    },
  },
  mounted() {
    if (this.action === 'update') {
      this.form = { value: { validations: { required: false } }, ...this.initialValues }
    } else {
      this.form.value.items = ['']
      this.form = { value: { validations: { required: false } }, ...this.initialValues }
    }
  },
  methods: {
    selectComparator(a, b) {
      return a.fieldID && b.fieldID && a.fieldID === b.fieldID
    },
    addAnotherOption() {
      if (this.form.value.items.at(-1) === '') {
        return
      }
      this.form.value.items.push('')
    },
    deleteOption(index) {
      this.form.value.items.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.disabled-button {
  opacity: 50%;
}

.promo-text {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 1.125rem;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.add-another-container {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 2rem;
  margin-top: 0.75rem;
}

::v-deep .v-input--selection-controls .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.button-label {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #333333;
}

.switch-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 4.5rem;
}
</style>
